import React from 'react';

export const EditIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15.969"
    viewBox="0 0 16 15.969"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M847.669,535.445l-1.553,1.546L843,533.87l1.553-1.546a1.1,1.1,0,0,1,1.561,0l1.56,1.561A1.1,1.1,0,0,1,847.669,535.445ZM835,548h-3v-3l10-10,3,3Z"
      transform="translate(-832 -532.031)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/edit-icon.js